var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRocket = function SvgIconRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 110,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__a)",
    d: "m54.818 74.676-5.25.065-1.026-1.94 7.248-.098z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__b)",
    d: "M69.725 56.104c-1.667-2.629-4.208-4.453-7.566-5.471a218 218 0 0 1-2.896 13.03c3.192 1.38 8.039 5.566 8.664 18.267.01.207.162.377.37.406a.432.432 0 0 0 .469-.278c5.219-14.485 3.404-22.11.962-25.95z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__c)",
    d: "M34.165 56.585c1.595-2.669 4.084-4.567 7.417-5.676a218 218 0 0 0 3.25 12.944c-3.153 1.465-7.889 5.782-8.165 18.495a.43.43 0 0 1-.355.413q-.036.009-.07.007a.435.435 0 0 1-.409-.272c-5.612-14.341-4.002-22.007-1.667-25.918z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__d)",
    d: "M51.193.868c-.094.076-9.75 5.543-12.093 22.875s8.418 48.978 8.447 49.078l9.24-.126c.023-.1 9.926-32.028 7.111-49.289C61.088 6.143 51.288.941 51.193.868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__e)",
    d: "M51.193.867c-.085.064-7.404 4.223-10.848 16.726 3.539.395 7.254.586 11.08.532a88 88 0 0 0 11.061-.832C58.705 4.889 51.273.935 51.19.87z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__f)",
    d: "M58.315 29.572a6.783 6.783 0 1 0-13.474-1.578 6.783 6.783 0 0 0 13.474 1.578"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__g)",
    d: "M57.537 28.698a5.965 5.965 0 1 1-11.931.161 5.965 5.965 0 0 1 5.885-6.047 5.965 5.965 0 0 1 6.046 5.886"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__h)",
    d: "M56.201 25.016c.616.91.986 2 1.002 3.175a5.799 5.799 0 0 1-11.586.405c-.001.083-.01.164-.008.25a5.97 5.97 0 0 0 6.046 5.886 5.97 5.97 0 0 0 5.885-6.047 5.94 5.94 0 0 0-1.335-3.672z",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#79678D",
    d: "M55.683 26.114a2.3 2.3 0 0 0-.25-.577c-.248-.399-.612-.768-1.06-.93-.383-.14-.752-.006-.706.447.054.503.726.71.941 1.157.088.177.136.373.245.54.246.389.7.353.846-.093.053-.16.037-.358-.012-.547z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#79678D",
    d: "M55.632 25.606a1.9 1.9 0 0 0-.316-.48c-.285-.325-.67-.597-1.1-.674-.367-.065-.68.112-.567.509.126.444.765.53 1.025.897.105.147.18.317.303.45.284.314.688.212.745-.213a.9.9 0 0 0-.097-.49z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#79678D",
    d: "M47.725 25.27c-.144.108-.28.25-.377.376-.252.335-.469.77-.532 1.248-.054.405.088.733.4.578.349-.169.417-.87.707-1.187.113-.126.245-.22.352-.363.244-.33.166-.764-.166-.797-.12-.014-.258.05-.383.138z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#79678D",
    d: "M47.742 25.185c-.09.05-.18.124-.247.187-.17.175-.326.414-.397.682-.059.23-.004.426.187.363.212-.073.304-.473.492-.632.075-.062.16-.11.231-.185.166-.172.153-.428-.036-.472-.07-.016-.15.01-.233.054z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#79678D",
    d: "M56.278 27.787a.26.26 0 0 1-.26.265.26.26 0 0 1-.264-.26.26.26 0 0 1 .26-.264.26.26 0 0 1 .264.259M49.119 24.619a.197.197 0 0 1-.201.203.197.197 0 0 1-.203-.2.197.197 0 0 1 .2-.204.197.197 0 0 1 .203.2",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#79678D",
    d: "M56.212 27.639a.2.2 0 0 1-.197.2.2.2 0 0 1-.2-.197.2.2 0 0 1 .196-.2.2.2 0 0 1 .2.197M49.041 24.555a.14.14 0 0 1-.138.14c-.08.002-.137-.06-.14-.139a.14.14 0 0 1 .278 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__i)",
    d: "m52.58 82.555-.682.01-2.44-23.996.303-8.484 4.074-.056.535 8.473z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__j)",
    d: "m54.82 74.676-5.251.073s-6.91 8.464 2.92 34.289l.335-.003c9.127-26.08 1.992-34.356 1.992-34.356z",
    opacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rocket_svg__k)",
    d: "m54.819 74.675-5.251.072s-3.834 5.829 2.949 23.647c6.297-17.993 2.301-23.719 2.301-23.719"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__a",
    x1: 48.631,
    x2: 55.877,
    y1: 73.808,
    y2: 73.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#673266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72356D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#903E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BA4B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BE53A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CA6AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DD8FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8C2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FFCFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFD5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFE8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__b",
    x1: 67.655,
    x2: 80.445,
    y1: 80.87,
    y2: 56.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__c",
    x1: 35.892,
    x2: 43.659,
    y1: 81.46,
    y2: 50.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5EAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__d",
    x1: 38.775,
    x2: 65.123,
    y1: 37.458,
    y2: 37.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F21B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#FFD291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__e",
    x1: 34.412,
    x2: 60.822,
    y1: 22.122,
    y2: 5.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#BA4B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BE53A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CA6AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#DD8FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#F8C2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#FFCFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__f",
    x1: 46.965,
    x2: 56.431,
    y1: 33.651,
    y2: 23.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#372345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3B2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#47274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5B2E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#773670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9B4189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BA4B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BE53A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CA6AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DD8FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F8C2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__g",
    x1: 45.676,
    x2: 57.607,
    y1: 28.889,
    y2: 28.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79678D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5B4C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3F335D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2A204C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1B123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#120A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#100836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#130A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1D1441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2E234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#463962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#64547C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79678D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__h",
    x1: 45.693,
    x2: 57.624,
    y1: 30.014,
    y2: 29.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79678D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5B4C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3F335D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2A204C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1B123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#120A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#100836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#130A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1D1441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2E234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#463962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#64547C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79678D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__i",
    x1: 51.085,
    x2: 54.544,
    y1: 66.281,
    y2: 66.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#FFA16E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__j",
    x1: 52.733,
    x2: 52.266,
    y1: 109.061,
    y2: 74.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FEF4C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FED88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FED07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FECA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FEB973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FE9D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FE775C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rocket_svg__k",
    x1: 53.208,
    x2: 52.265,
    y1: 92.112,
    y2: 74.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FEF4C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FED88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FED07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FECA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FEB973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FE9D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FE775C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F59"
  })))));
};
export default SvgIconRocket;